import { UrlConstant } from "../../../urlConstant/UrlConstant"
import { useHttpRequest } from "../../../utils"
import useCallBack, { Callbacks } from "../../../utils/callback/useCallBack"
import { CommunicationLogInput } from "../types"


export const CreateCommunicationLogMutation = <T>(payload: CommunicationLogInput, callbacks?: Callbacks<T>) => {
    const { onSuccess, onError, onLoading } = useCallBack<any>(callbacks)

    const { postRequest } = useHttpRequest({})
    return async () => {
        const createCommunication = async () => {
            try {
                const response = await postRequest(`${UrlConstant.GMailAddOn}/${UrlConstant.CreateCommunication}`, [payload])
                const data = await response
                return data
            } catch (error) {
                onError(error as Error)
            }
        }
        try {
            const res = await createCommunication()
            if (res) {
                if (res.succeeded) {
                     onSuccess(res.data?.[0])
                }
                else {
                    onError({message:res.message, name:''});
                }
            }
        } catch (error) {
            onError(error as Error)
        } finally {
            onLoading(false)
        }
    }
}
